import { createFileRoute } from "@tanstack/react-router";

import { Section, SectionHeader } from "@roqua/components/sections";

import { PageTitle } from "@/components/PageTitle";

export const Route = createFileRoute("/$organizationKey/$dossierId/design/colors")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <>
      <PageTitle title="designColors" />
      <Section variant="header">
        <SectionHeader header="Kleurenpalet RoQua" />
      </Section>
      <Section>
        <div className="bg-background mb-4 space-y-4 rounded-md p-4">
          <div>
            <header className="mb-2 text-lg font-semibold">Grayscale</header>

            <div className="mb-8 grid grid-cols-6 border text-sm">
              <div className="flex flex-col">
                <div className="bg-background flex aspect-square flex-col items-center justify-center font-mono text-xs">
                  <span>1 </span>
                  <span>0</span>
                  <span>0</span>
                </div>
                <div className="font-semibold">background</div>
                <div>card</div>
                <div>popover</div>
                <div>primary-foreground</div>
                <div>muted-contrast</div>
              </div>
              <div className="flex flex-col">
                <div className="bg-page flex aspect-square flex-col items-center justify-center font-mono text-xs">
                  <span>0.95</span>
                  <span>0.0034</span>
                  <span>247.86</span>
                </div>
                <div>page</div>
              </div>
              <div className="flex flex-col">
                <div className="bg-border flex aspect-square flex-col items-center justify-center font-mono text-xs">
                  <span>0.9</span>
                  <span>0.013</span>
                  <span>255.5</span>
                </div>
                <div>border</div>
                <div>section-content-from</div>
              </div>
              <div className="flex flex-col">
                <div className="bg-muted text-muted-contrast flex aspect-square flex-col items-center justify-center font-mono text-xs">
                  <span>0.55 </span>
                  <span>0.04</span>
                  <span>257</span>
                </div>
                <div>muted</div>
              </div>
              <div className="flex flex-col">
                <div className="bg-foreground text-background flex aspect-square flex-col items-center justify-center font-mono text-xs">
                  <span>0.21</span>
                  <span>0.04</span>
                  <span>266</span>
                </div>
                <div>foreground</div>
                <div>card-foreground</div>
                <div>popover-foreground</div>
              </div>
              <div className="flex flex-col">
                <div className="text-background flex aspect-square flex-col items-center justify-center bg-black font-mono text-xs">
                  <span>0</span>
                  <span>0</span>
                  <span>0</span>
                </div>
                <div>black</div>
              </div>
            </div>
          </div>

          <div>
            <header className="mb-2 mt-8 text-lg font-semibold">Blue tones</header>

            <div className="grid grid-cols-8 border text-sm">
              <div className="flex flex-col">
                <div className="bg-section-middle-from flex aspect-square flex-col items-center justify-center font-mono text-xs">
                  <span>0.6</span>
                  <span>0.17</span>
                  <span>223</span>
                </div>
                <div>section-middle-from</div>
              </div>
              <div className="flex flex-col">
                <div className="bg-section-middle-to flex aspect-square flex-col items-center justify-center font-mono text-xs">
                  <span>0.85</span>
                  <span>0.055</span>
                  <span>223</span>
                </div>
                <div>section-middle-to</div>
              </div>
              <div className="flex flex-col">
                <div className="bg-hero text-section-header-contrast flex aspect-square flex-col items-center justify-center font-mono text-xs">
                  <span>0.68</span>
                  <span>0.16</span>
                  <span>254</span>
                </div>
                <div>hero</div>
                <div>section-header-from</div>
              </div>

              <div className="flex flex-col">
                <div className="bg-section-header-to text-section-header-contrast flex aspect-square flex-col items-center justify-center font-mono text-xs">
                  <span>0.6</span>
                  <span>0.17</span>
                  <span>254</span>
                </div>
                <div>section-header-to</div>
              </div>

              <div className="flex flex-col">
                <div className="bg-ring text-ring-contrast flex aspect-square flex-col items-center justify-center font-mono text-xs">
                  <span>0.6</span>
                  <span>0.18</span>
                  <span>254</span>
                </div>
                <div>ring</div>
              </div>

              <div className="flex flex-col">
                <div className="bg-primary-hover text-primary-contrast flex aspect-square flex-col items-center justify-center font-mono text-xs">
                  <span>0.5</span>
                  <span>0.16</span>
                  <span>254</span>
                </div>
                <div>primary-hover</div>
              </div>

              <div className="flex flex-col">
                <div className="text-primary-contrast flex aspect-square flex-col items-center justify-center bg-primary font-mono text-xs">
                  <span>0.454</span>
                  <span>0.135</span>
                  <span>254</span>
                </div>
                <div className="font-semibold">primary</div>
              </div>
            </div>
          </div>

          <div>
            <header className="mb-2 mt-8 text-lg font-semibold">Misc colors</header>

            <div className="grid grid-cols-6 border text-sm">
              <div className="flex flex-col">
                <div className="flex aspect-square flex-col items-center justify-center bg-warning font-mono text-xs">
                  <span>0.9</span>
                  <span>0.165</span>
                  <span>98</span>
                </div>
                <div className="font-semibold">warning</div>
              </div>

              <div className="flex flex-col">
                <div className="bg-error text-error-contrast flex aspect-square flex-col items-center justify-center font-mono text-xs">
                  <span>0.5583</span>
                  <span>0.1672</span>
                  <span>28.8</span>
                </div>
                <div>error</div>
              </div>

              <div className="flex flex-col">
                <div className="flex aspect-square flex-col items-center justify-center bg-success font-mono text-xs">
                  <span>0.86</span>
                  <span>0.17</span>
                  <span>158</span>
                </div>
                <div>success</div>
              </div>

              <div className="flex flex-col">
                <div className="bg-accent flex aspect-square flex-col items-center justify-center font-mono text-xs">
                  <span>H</span>
                  <span>S</span>
                  <span>L</span>
                </div>
                <div>accent</div>
              </div>

              <div className="flex flex-col">
                <div className="bg-accent-foreground flex aspect-square flex-col items-center justify-center font-mono text-xs">
                  <span>H</span>
                  <span>S</span>
                  <span>L</span>
                </div>
                <div>accent-foreground</div>
              </div>
            </div>
          </div>
          <div>
            <header className="mb-2 mt-8 text-lg font-semibold">Text only colors</header>

            <div className="grid grid-cols-6 border text-sm">
              <div className="flex flex-col">
                <div className="bg-foreground text-error-text flex aspect-square flex-col items-center justify-center font-mono text-xs">
                  <span>0.8</span>
                  <span>0.116</span>
                  <span>18</span>
                </div>
                <div>error-text (toasts)</div>
              </div>
            </div>
          </div>
        </div>
      </Section>
    </>
  );
}
